import React from 'react';

/** Render only the backend's safe diagnostic fields, as escaped text. */
export default function SubmissionErrorDetails({ error }: { error: unknown }) {
  if (!error || typeof error !== 'object' || Array.isArray(error)) return null;
  const value = error as Record<string, unknown>;
  const message = typeof value.message === 'string' ? value.message : '';
  const code = typeof value.code === 'string' ? value.code : '';
  const status = typeof value.httpStatus === 'number' && Number.isInteger(value.httpStatus) ? value.httpStatus : null;
  const fields = Array.isArray(value.fields) ? value.fields.filter((field): field is string => typeof field === 'string') : [];
  if (!message && !code && status === null && fields.length === 0) return null;
  return <div aria-label="Submission diagnostics">
    {message && <p>{message}</p>}
    {(code || status !== null) && <p>{code && <>Code: {code}</>}{code && status !== null && ' · '}{status !== null && <>HTTP {status}</>}</p>}
    {fields.length > 0 && <p>Fields: {fields.join(', ')}</p>}
  </div>;
}
